import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoadingSpinnerComponent } from "./common-ui/loading-spinner/loading-spinner.component";
import { TableUiComponent } from "./common-ui/table-ui/table-ui.component";
import { TablePaginationComponent } from "./common-ui/table-pagination/table-pagination.component";
import { CmreqModule, MaterialModule } from "@intrasense/material";
import { TableActionButtonsComponent } from "./utils/table-features/table-action-buttons/table-action-buttons.component";
import { TableViewActionsComponent } from "./utils/table-features/table-view-actions/table-view-actions.component";
import { TableActionsComponent } from "./utils/table-features/table-actions/table-actions.component";
import { TableDropTextActionsComponent } from "./utils/table-features/table-drop-text-actions/table-drop-text-actions.component";
import { ImportcsvDialogComponent } from "./common-ui/importcsv-dialog/importcsv-dialog.component";
import { FeatureLibraryModule } from "@intrasense/feature-library";
import { ViewTeamDetailComponent } from "./common-ui/view-team-detail/view-team-detail.component";
import { SingleSpinnerComponent } from './common-ui/single-spinner/single-spinner.component';
import { ErrorAllComponent } from "./error-pages/error-all/error-all.component";
import { PageNotFoundComponent } from "./error-pages/page-not-found/page-not-found.component";
import { NoDataUiComponent } from './common-ui/no-data-ui/no-data-ui.component';
import { BtnLoaderComponent } from './common-ui/btn-loader/btn-loader.component';
import { CommonViewDetailComponent } from './common-ui/common-view-detail/common-view-detail.component';

@NgModule({
  imports: [CommonModule, MaterialModule, CmreqModule, FeatureLibraryModule],
  declarations: [
    LoadingSpinnerComponent,
    TableUiComponent,
    TablePaginationComponent,
    TableActionButtonsComponent,
    TableViewActionsComponent,
    TableActionsComponent,
    TableDropTextActionsComponent,
    ImportcsvDialogComponent,
    ViewTeamDetailComponent,
    SingleSpinnerComponent,
    ErrorAllComponent,
    PageNotFoundComponent,
    NoDataUiComponent,
    BtnLoaderComponent,
    CommonViewDetailComponent
  ],
  exports: [
    LoadingSpinnerComponent,
    TableUiComponent,
    TablePaginationComponent,
    TableActionButtonsComponent,
    TableViewActionsComponent,
    TableActionsComponent,
    TableDropTextActionsComponent,
    ImportcsvDialogComponent,
    ViewTeamDetailComponent,
    SingleSpinnerComponent,
    ErrorAllComponent,
    PageNotFoundComponent,
    NoDataUiComponent,
    BtnLoaderComponent
  ],
})
export class SharedModule {}
